<div [ngClass]="isScrolled ? 'sticky top-0 z-50 translate-y-0 shadow-md transition-all' : 'absolute w-full'">
  <app-header></app-header>
</div>
<div class="general-shell content as-body pt-16">
  <router-outlet></router-outlet>
</div>
<app-footer class="mt-auto"></app-footer>
